module.exports = __webpack_public_path__ + "static/media/login-bg.ac96882e.png";